import { RapAppLinkComponent } from './rap-app-link/rap-app-link.component'

export function rapComponents() {
  return [
    RapAppLinkComponent,
  ]
}
